import {Vue} from '~/addiesaas'
import auth from './auth'
import controls from './controls'
import forms from './forms'
import views from './views'
import modals from './modals'
import containers from './containers'
import settings from './settings'
import LeftBar from './left-bar'
import SvgIcon from './svg-icon'
import ResizeSensor from './resize-sensor'
import SettingsForm from './settings-form'
import DragAndDropImageUpload from './drag-and-drop-image-upload'
import PostComments from './post-comments'
import SettingsImageActions from './settings-image-actions'
import ShoppingCart from './shopping-cart'

const requires = {
    ...auth,
    ...controls,
    ...forms,
    ...views,
    ...modals,
    ...containers,
    ...settings,
    LeftBar,
    SvgIcon,
    ResizeSensor,
    ...SettingsForm,
    DragAndDropImageUpload,
    PostComments,
    SettingsImageActions,
    ShoppingCart,
}

Object.values(requires).forEach(component => {
    Vue.component(component.name, component)
})

export default requires
